import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const OAuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    // Wait for auth to complete, then redirect
    if (!loading && user) {
      // Get the saved redirect path or default to /trips
      const redirectPath = sessionStorage.getItem('auth_redirect_path') || '/trips';
      sessionStorage.removeItem('auth_redirect_path'); // Clean up
      console.log(`✅ OAuth complete, redirecting to ${redirectPath}`);
      navigate(redirectPath, { replace: true });
    } else if (!loading && !user) {
      // Auth failed, redirect to home
      console.log('❌ OAuth failed, redirecting to home');
      sessionStorage.removeItem('auth_redirect_path'); // Clean up
      navigate('/', { replace: true });
    }
  }, [user, loading, navigate]);

  // Show a brief loading state
  return (
    <div className="max-w-2xl mx-auto p-6 text-center">
      <div className="animate-pulse">
        <h1 className="text-xl font-semibold mb-2">Signing you in…</h1>
      </div>
    </div>
  );
};

export default OAuthCallback;